import { TSpecSummary, TClassSummary } from '../../types/utilityTypes';

export const findSpecAndClassBySlugs = (
  specs: TSpecSummary[],
  classes: TClassSummary[],
  specSlug?: string,
  classSlug?: string
) => {
  const cls = classes.find((c) => c.slug === classSlug);
  if (cls) {
    const spec = specs.find((s) => s.slug === specSlug && s.class_id === cls.id);
    if (spec) {
      return { spec, cls };
    }
  }
  return { spec: null, cls: null };
};

export const findClassBySlug = (classes: TClassSummary[], classSlug?: string) => {
  if (!classSlug) {
    return null;
  }
  return classes.find((c) => c.slug === classSlug);
};
